import { Component, OnInit, OnDestroy, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { NgbModalRef, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { LabelStyleDialogService } from './label-style-dialog.service.';
import { HexString } from 'src/app/types/@types/hex-string';
import { AlignmentOption } from 'src/app/types/allignments';
import { Grid9Position } from 'src/app/types/grid9-position';
import { XYOffset } from 'src/app/types/xyoffset';
import { LabelStyle, LabelStyleInfo } from 'src/app/types/LabelStyle';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { GlowSize } from 'src/app/types/glow-size';

@Component({
	selector: 'app-label-style-dialog',
	templateUrl: './label-style-dialog.component.html',
	styleUrls: ['./label-style-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LabelStyleDialogComponent implements OnInit {

	public title = 'Label Style Editor';
	public font = 'RobotoMonoRegular';
	public fontColor: HexString = '#000';
	public fontSize = '10';
	public alignment: AlignmentOption = 'left';
	public hasGlow = false;
	public outlineWidth = 0;
	public glowColor: HexString = '#000';
	public glowSize: GlowSize = 0;
	public includeShadow = false;
	public shadowColor: HexString = '#000';
	public shadowOffset: XYOffset = { x: 0, y: 0 };
	public autoPosition = true;
	public position: Grid9Position = 'auto';
	public offset: XYOffset = { x: 0, y: 0 };
	public autoAngle = true;
	public angle: 'auto' | number = 0;
	public viewOnly = false;
	private style: LabelStyle;
	private handler: AnyHandler;

	@HostBinding('class.work-view') workView = true;
	constructor(private activeModal: NgbActiveModal, private changes: ChangeDetectorRef) { }

	ngOnInit() {
		this.style = this.GetStyle();
		this.style = this.style;
	}

	Show(info: any) {
		if (!!info.handler) {
			this.handler = info.handler;
		}
		if (!!info.title) {
			this.title = info.title;
		}
		if (!!info.style) {
			this.SetStyle(info.style);
		}
		
		this.viewOnly = info.viewOnly;
		this.changes.detectChanges();
	}
	GetStyle(): LabelStyleInfo {
		const style: LabelStyleInfo = {
			font: this.font,
			size: Number(this.fontSize),
			color: this.fontColor,
			align: this.alignment
		};
		if (this.hasGlow) {
			style.outlinecolor = this.glowColor;
			style.outlinewidth = this.glowSize;
		}
		if (this.includeShadow === true) {
			style.shadowcolor = this.shadowColor;
			style.shadowsizex = this.shadowOffset.x;
			style.shadowsizey = this.shadowOffset.y;
		}
		if (this.autoPosition === false) {
			if (this.position !== 'auto') {
				style.offsetx = this.offset.x;
				style.offsety = this.offset.y;
			}
			style.position = this.position;
		}
		if (this.autoAngle === false) {
			style.angle = this.angle;
		}
		return style;
	}
	SetStyle(style: LabelStyleInfo) {
		if (typeof style === 'string') {
			if (style === '') {
				this.style = '';
			} else {
				this.style = JSON.parse(style);
			}
		} else {
			this.style = style;
		}

		this.font = style.font;
		this.fontSize = (!!style.size) ? '' + style.size : '10';
		this.fontColor = (!!style.color) ? style.color : '#000000';
		this.alignment = (!!style.align) ? style.align : 'left';
		this.position = (!!style.position) ? style.position : 'auto';
		this.glowSize = (!!style.outlinewidth) ? style.outlinewidth : 0;
		this.hasGlow = this.glowSize > 0;
		this.glowColor = (!!style.outlinecolor) ? style.outlinecolor : '#000';
		this.autoAngle =  ([null,undefined].indexOf(style.angle) > -1) ? true : (style.angle === 'auto');
		this.angle = (style.angle === 'auto') ? 0 : style.angle;

		const shadowX = (!!style.shadowsizex) ? style.shadowsizex : 0;
		const shadowY = (!!style.shadowsizey) ? style.shadowsizey : 0;
		this.shadowOffset = { x: shadowX, y: shadowY };

		this.includeShadow = (!!style.shadowcolor);
		this.shadowColor = (!!style.shadowcolor) ? style.shadowcolor : '#000';

		const offsetX = (!!style.offsetx) ? style.offsetx : 0;
		const offsetY = (!!style.offsety) ? style.offsety : 0;
		this.offset = { x: offsetX, y: offsetY };

		if (['auto', 'ul', 'uc', 'ur', 'cl', 'cc', 'cr', 'll', 'lc', 'lr'].indexOf(this.position) === -1) {
			this.position = 'auto';
		}
		this.autoPosition = (this.position === 'auto');
	}
	GlowSizeChanged(event: any) {
		event = null;
		this.hasGlow = this.glowSize > 0;
		this.changes.detectChanges();
	}
	AutoAngleChanged(event: any) {
		this.changes.detectChanges();
	}
	AutoPosChanged(event: any) {
		event = null;
		if (this.autoPosition === false) {
			if (this.position === 'auto') {
				this.position = 'cc';
			}
		}
		this.changes.detectChanges();
	}
	HandleButtonOne() {
		this.NotifyListeners();
		this.activeModal.close();
	}
	HandleButtonTwo() {
		this.activeModal.close();
	}
	NotifyListeners() {
		this.handler(this.GetStyle());

	}
}

@Component({
	selector: 'app-label-style-entry',
	template: ''
})
export class LabelStyleEntryComponent implements OnDestroy {
	modalRef: NgbModalRef;
	subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
	lastTitle: string | null = null;

	constructor(private modalService: NgbModal, private service: LabelStyleDialogService) {

		this.subscriptionMgr.Subscribe(this.service.request$, (info: any) => {
			this.modalRef = this.modalService.open(LabelStyleDialogComponent, { backdrop: 'static' });
			(this.modalRef.componentInstance as LabelStyleDialogComponent).Show(info);
		});


	}
	ngOnDestroy() {
		this.subscriptionMgr.CancelSubscriptions();
	}
}
